import React from 'react';
import { LESSON_TYPES, MANUAL_EVALUATION } from 'Constants/General';
import { AutoEvaluationIcon, ManualEvaluationIcon } from 'Images';
import { useHistory } from 'react-router-dom';
import useTranslation from 'Hooks/useTranslation';

/** Status values that block a new opportunity request */
const BLOCKING_REQUEST_STATUSES = ['pending', 'approved', 'rejected'];

/**
 * @param {import('types').UserEvaluationI} userEvaluation
 * @param {string} courseName
 * @param {string} courseId
 * @returns
 */
const useEvaluation = (userEvaluation, courseName, courseId) => {
  const { t2 } = useTranslation('CourseDetails');
  const history = useHistory();

  const isManualEvaluation = userEvaluation?.lessonTypeId === LESSON_TYPES.MANUAL_EVALUATION;
  const isAutoEvaluation = userEvaluation?.lessonTypeId === LESSON_TYPES.AUTOMATIC_EVALUATION;

  const { attemptsCount, maxAttempts, opportunityRequest, grade } = userEvaluation ?? {};

  const attemptsExhausted = typeof attemptsCount === 'number' && attemptsCount > 0 && attemptsCount === maxAttempts;

  const hasBlockingRequest =
    opportunityRequest != null && BLOCKING_REQUEST_STATUSES.includes(opportunityRequest.status);

  const canRequestOpportunity =
    isAutoEvaluation && attemptsExhausted && typeof grade === 'number' && grade < 70 && !hasBlockingRequest;

  const startTest = () => {
    history.push({
      pathname: '/cursos/informacion-de-examen',
      state: {
        titleCourse: courseName,
        titleLesson: userEvaluation.name,
        totalQuestions: userEvaluation?.count?.totalQuestions,
        lessonId: userEvaluation.lessonId,
        duration: userEvaluation.duration,
        courseId,
      },
    });
  };

  const icon = <img src={isManualEvaluation ? ManualEvaluationIcon : AutoEvaluationIcon} style={{ height: '100%' }} />;

  const typeLabel = isManualEvaluation ? t2('ManualEvaluation') : t2('AutomaticEvaluation');

  return { icon, typeLabel, isManualEvaluation, isAutoEvaluation, attemptsExhausted, canRequestOpportunity, startTest };
};

export default useEvaluation;
